import { jsx as _jsx } from "react/jsx-runtime";
/**
 * NotificationsToast — bridges `NotificationsContext.latestToast` to a
 * transient `<CustomSnackbar>`. Rendered once at the App root.
 */
import React from 'react';
import CustomSnackbar from '../CustomSnackbar/CustomSnackbar';
import { useNotifications } from '../../context/NotificationsContext';
const typeToSeverity = (type) => {
    if (type.endsWith('.failed'))
        return 'error';
    if (type.endsWith('.completed') || type.endsWith('.saved'))
        return 'success';
    return 'info';
};
const NotificationsToast = () => {
    const { latestToast, clearLatestToast } = useNotifications();
    const [open, setOpen] = React.useState(false);
    const [snapshot, setSnapshot] = React.useState(null);
    React.useEffect(() => {
        if (!latestToast)
            return;
        const { notification } = latestToast;
        setSnapshot({
            msg: notification.body ? `${notification.title} — ${notification.body}` : notification.title,
            sev: typeToSeverity(notification.type),
        });
        setOpen(true);
        // Acknowledge immediately so a rapid second event still triggers.
        clearLatestToast();
    }, [latestToast, clearLatestToast]);
    if (!snapshot)
        return null;
    return (_jsx(CustomSnackbar, { open: open, message: snapshot.msg, type: snapshot.sev, autoHideDuration: 5000, onClose: () => setOpen(false) }));
};
export default NotificationsToast;
